function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    const IncValue = this.input.value;
    var priceElement =  document.querySelector('.product__info-container');
    if (!priceElement) return;
    var currentPrice =  priceElement?.querySelector('.product-price-current');  
    if (!currentPrice) return; 
    const priceData = currentPrice?.dataset.price;   
    var SubPrice = priceData.replace(/[^0-9\.]/g, '');   
    var ReultPrice =  SubPrice.replace(/^(\.+)/g, '');     
    var EvalPrice = parseInt(ReultPrice)    
    var subtotal = (IncValue * EvalPrice);                   
    var subtotalElement =  document.getElementById('subtotal-value'); 
    if(subtotalElement)   
      subtotalElement.innerText = Shopify.formatMoney(subtotal+'.00', DT_THEME.moneyFormat);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
    
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    var topBarHeight = document.getElementById('shopify-section-top-bar').offsetHeight;    
    document.getElementById("menu-drawer").style.top = '-'+topBarHeight+"px";    
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;    
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
  
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slider-options]');
    this.init();
  }

  init() {
    const predefine = {
      effect: 'slide',
      direction: 'horizontal',
      autoplay: true,
      autoplaySpeed: 5,
      space: 30,
      center: true,
      options: {},
    };    
    const slider_options = this.slider.getAttribute('data-slider-options');
    if (slider_options === null || slider_options === '') {
      return null;
    }
    const grouping = $.extend(true, predefine, JSON.parse(slider_options));
    
    const isNumberic = /^\d+$/;
    Object.keys(grouping).forEach((key) => {
      if (typeof grouping[key] === 'string' && isNumberic.test(grouping[key])) {
        grouping[key] = parseInt(grouping[key], 10);
      }
    });
    let autoplay = false;
    if (grouping.auto_play > 0) {
      autoplay = {
        delay: grouping.auto_play * 1000,
      };
    }
    let loop = false;
    if (grouping.loop === 'true' || grouping.loop === true) {
      loop = true;
    }
    const option = $.extend(true, {
      init: false,
      spaceBetween: 30,
      loop,
      autoplay,
      navigation: {
        nextEl: this.slider.querySelector('.swiper-button-next'),
        prevEl: this.slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      lazy: true,
      effect: grouping.effect,
    }, grouping.options);
    const container = this.slider.querySelector('[data-swiper-slider]');
    const initiate = new Swiper(container, option);
    initiate.on('init', () => {
    initiate.update();
    });
    initiate.init();
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {     
  const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {   
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
updateInventoryStatus() {
    const inventoryNote = document.querySelector('.inventoryNote');
   if (!inventoryNote) return;
    const inventoryVisibility = document.querySelector('.inventory-form__label');
    if (this.currentVariant && this.currentVariant.available) {
      const inventoryHtml = `${variantStock[this.currentVariant.id]}`;     
      inventoryVisibility.classList.remove('visibility-hidden');
      inventoryNote.textContent = inventoryHtml;
 
    } else {
      inventoryNote.innerHTML = "";
      inventoryVisibility.classList.add('visibility-hidden');
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const qty = document.getElementById(`Quantity-template-${this.dataset.section}`);
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
        const price = document.getElementById(`price-${this.dataset.section}`);
       // if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const subTotal = document.getElementById(`subtotal-${this.dataset.section}`);
        const destination2 = document.getElementById(`subtotal-${this.dataset.section}`);
        const source2 = html.getElementById(`subtotal-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source2 && destination2) destination2.innerHTML = source2.innerHTML;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
     const stickButton = document.getElementById('sticky-bar-button');
    
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
   
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');    
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');      
      addButtonText.textContent = window.variantStrings.addToCart;
    }

     if (!stickButton) return;    
    if (disable) {      
      stickButton.setAttribute('disabled', 'disabled');      
    } else {      
      stickButton.removeAttribute('disabled');      
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);    
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;        
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
class SwiperSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1,
            speed = t.speed ? t.speed : 300;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        if (t.auto_scroll === "true" || t.auto_scroll_mobile === "true") {
          s = {
            delay: 0,
            disableOnInteraction: false
          };
          speed = t.speed ? t.speed : 3000;
        }

        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: t.space != 'undefined' ? t.space : 30,
                loop: l,
                preventClicks: true,
                preventClicksPropagation: true,
                autoplay: s,
                speed: speed,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.auto_width === "true" ? "auto" : t.auto_width_mobile === "true" ? "auto" : t.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: t.space ? t.space : 16,
                        loop: t.auto_scroll === "true" || t.auto_scroll_mobile === "true" ? true : l
                    },
                    560: {
                        slidesPerView: t.auto_width === "true" ? "auto" : t.auto_width_mobile === "true" ? "auto" : t.tablet,
                        slidesPerColumn: 1,
                        loop: t.auto_scroll === "true" || t.auto_scroll_mobile === "true" ? true : l
                    },
                    992: {
                        slidesPerView: t.auto_width === "true" ? "auto" : t.auto_width_mobile === "true" ? "auto" : t.desktop,
                        slidesPerColumn: 1,
                        loop: t.auto_scroll === "true" || t.auto_scroll_mobile === "true" ? true : l
                    },
                    1200: {
                        slidesPerView: t.auto_width === "true" ? "auto" : t.desktop,
                        slidesPerColumn: 1,
                        loop: t.auto_scroll === "true" ? true : l
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('swiper-slider', SwiperSlider);

class FeaturedSwiperSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: 30,
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    390: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    781: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('featured-swiper-slider', FeaturedSwiperSlider);

/*collection-list*/
class CollectionSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                effect: "coverflow",
                spaceBetween: 0,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 300,
                    modifier: 1,
                    slideShadows: !0
                },
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1
                    },
                    560: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    768: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-collection-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("collection-slider", CollectionSlider);

class CollectionSwiperSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let l = !1;
        t.auto_play > 0 && (l = {
            delay: 1e3 * t.auto_play
        });
        let s = !1,
            o = !1;
        "true" === t.loop || !0 === t.loop ? s = !0 : 1 === t.loop ? (s = !0, o = !0) : (o = !1, s = !1);
        const r = $.extend(!0, {
                init: !1,
                spaceBetween: 30,
                loop: s,
                autoplay: l,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
          focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    570: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            p = new Swiper(n, r);
        p.on("init", (() => {
            p.update()
        })), p.init()
    }
}
customElements.define("collection-swiper-slider", CollectionSwiperSlider);
class Accordion {
    constructor(i) {
        this.el = i, this.summary = i.querySelector("summary"), this.content = i.querySelector(".accordion__content"), this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.summary.addEventListener("click", (i => this.onClick(i)))
    }
    onClick(i) {
        i.preventDefault(), this.el.style.overflow = "hidden", this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink()
    }
    shrink() {
        this.isClosing = !0;
        const i = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight}px`;
        this.animation && this.animation.cancel(), this.animation = this.el.animate({
            height: [i, t]
        }, {
            duration: 400,
            easing: "ease-out"
        }), this.animation.onfinish = () => this.onAnimationFinish(!1), this.animation.oncancel = () => this.isClosing = !1
    }
    open() {
        this.el.style.height = `${this.el.offsetHeight}px`, this.el.open = !0, window.requestAnimationFrame((() => this.expand()))
    }
    expand() {
        this.isExpanding = !0;
        const i = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight+this.content.offsetHeight}px`;
        this.animation && this.animation.cancel(), this.animation = this.el.animate({
            height: [i, t]
        }, {
            duration: 400,
            easing: "ease-out"
        }), this.animation.onfinish = () => this.onAnimationFinish(!0), this.animation.oncancel = () => this.isExpanding = !1
    }
    onAnimationFinish(i) {
        this.el.open = i, this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.el.style.height = this.el.style.overflow = ""
    }
}
document.querySelectorAll(".dt-details").forEach((i => {
    new Accordion(i)
}));
// $("#accordian li").click(function() {
//     var e = $(this),
//         o = e.closest("ul"),
//         t = o.find(".active"),
//         i = e.closest("li"),
//         l = i.hasClass("active"),
//         s = 0;
//     o.find("ul").slideUp(function() {
//         ++s == o.find("ul").length && t.removeClass("active");
//     });
//     if (!l) {
//         i.children("ul").slideDown();
//         i.addClass("active");
//     }
// });
// if ($(window).width() < 767) {
//     // Footer Menu Toggle
//     if ($(".footer_menu").length > 0) {
//         $(".footer_menu").hide();
//         $(".footer__title").each(function() {
//             $(this).find(".footer__title").on("click", function() {
//                 $(this).toggleClass("open");
//                 $(this).next("ul").slideToggle("slow");
//             });
//         });
//     }
//     // Footer Newsletter Toggle
//     if ($(".footer_newsletter").length > 0) {
//         $(".footer-block__newsletter").hide();
//         $(".footer-block__heading").each(function() {
//             $(this).find(".footer-block__heading").on("click", function() {
               
//                 $(this).toggleClass("open");
//                 $(".footer-block__newsletter").slideToggle("slow");
//             });
//         });
//     }
//     // Footer Address Toggle
//     if ($(".footer_address").length > 0) {
//         $(".footer--address").hide();
//         $(".footer_address").each(function() {
//             $(this).find(".footer-block__heading").on("click", function() {
               
//                 $(this).toggleClass("open");
//                 $(".footer--address").slideToggle("slow");
//             });
//         });
//     }
// }

$("#accordian li").click((function() {
    var e = $(this),
        o = e.closest("ul"),
        t = o.find(".active"),
        i = e.closest("li"),
        l = i.hasClass("active"),
        s = 0;
    o.find("ul").slideUp((function() {
        ++s == o.find("ul").length && t.removeClass("active")
    })), l || (i.children("ul").slideDown(), i.addClass("active"))
})), $(window).width() < 767 && ($(".footer-accordian .footer_menu .footer__title").length > 0 && ($(".footer_menu").hide(), $(".footer__title").each((function() {
    $(this).find(".footer__title").click((function() {
        $(this).toggleClass("open"), $(this).next("ul").slideToggle("slow")
    }))
}))), $(".footer_newsletter.footer-accordian ").length > 0 && ($(".footer-block__newsletter").hide(), $(".footer-block__heading").each((function() {
    $(this).find(".footer-block__heading").click((function() {
        $(this).toggleClass("open"), $(".footer-block__newsletter").slideToggle("slow")
    }))
}))), $(".footer_address").length > 0 && ($(".footer--address").hide(), $(".footer_address").each((function() {
    $(this).find(".footer-block__heading").click((function() {
        $(this).toggleClass("open"), $(".footer--address").slideToggle("slow")
    }))
}))));

$(document).ready(function () {
    const isAccordionEnabled = $("#enable_accordian"); // Fetch the element with the ID
    console.log("Accordion enabled:", isAccordionEnabled.length > 0); // Check if it exists

    if (isAccordionEnabled) {
        // Initialize accordion functionality
        document.querySelectorAll(".dt-details").forEach((i) => {
            new Accordion(i); // Ensure Accordion is defined elsewhere
        });

        // Footer menu toggle for smaller screens
        if (window.innerWidth < 767) {
            if ($("footer-accordian .footer_menu .footer__title").length > 0) {
                $(".footer_menu").hide();
                $(".footer-links").each(function () {
                    $(this)
                        .find(".footer__title")
                        .on("click", function () {
                            $(this).toggleClass("open");
                            $(this).next("ul").slideToggle("slow");
                        });
                });
            }

            if ($(".footer_newsletter.footer-accordian").length > 0) {
                $(".footer-block__newsletter").hide();
                $(".footer_newsletter").each(function () {
                    $(this)
                        .find(".footer-block__heading")
                        .on("click", function () {
                            $(this).toggleClass("open");
                            $(".footer-block__newsletter").slideToggle("slow");
                        });
                });
            }

            if ($(".footer_address").length > 0) {
                $(".footer--address").hide();
                $(".footer_address").each(function () {
                    $(this)
                        .find(".footer-block__heading")
                        .on("click", function () {
                            $(this).toggleClass("open");
                            $(".footer--address").slideToggle("slow");
                        });
                });
            }
        }
    } else {
        // If accordion is not enabled, ensure footer-block__details-content is displayed
        document.querySelectorAll(".footer-block__details-content").forEach((el) => {
            el.style.display = "block";
        });
    }
});

class InstaSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                spaceBetween: 0,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1
                    },
                    481: {
                        slidesPerView: 2,
                        slidesPerColumn: 1
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerColumn: 1
                    },
                    940: {
                        slidesPerView: 4,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    1440: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-insta-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("insta-slider", InstaSlider);

class FlexSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = $.extend(!0, {
                init: !1,
                spaceBetween: 0,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1
                    },
                    560: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-flex-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("flex-slider", FlexSlider);

class RecommendationSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = $.extend(!0, {
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = $.extend(!0, {
                init: !1,
                spaceBetween: 30,
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    576: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1541: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('recommendation-slider', RecommendationSlider);

//variant swatch color 
function handleSwatchGroups(container) {
  container.querySelectorAll('.variant-option-color').forEach(function (swatchGroup) {
    const swatches = swatchGroup.querySelectorAll('.color-values');
    const maxVisible = 3;

    if (swatches.length > maxVisible) {
      swatches.forEach((swatch, index) => {
        if (index >= maxVisible) {
          swatch.classList.add('hidden-swatch');
          swatch.style.display = 'none';
        }
      });

      const toggleBtn = swatchGroup.querySelector('.color-values-plus a');
      if (toggleBtn && !toggleBtn.dataset.bound) {
        toggleBtn.dataset.bound = "true";
        toggleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          swatches.forEach(swatch => {
            swatch.style.display = 'inline-block';
          });
          toggleBtn.closest('.color-values-plus').style.display = 'none';
        });
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  
  handleSwatchGroups(document);
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            handleSwatchGroups(node);
          }
        });
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

class VariantCheckboxes extends HTMLElement {
  connectedCallback() {
    this.addBtn   = this.querySelector('.multiple-variant-picker__add-btn');
    this.totalEl  = this.querySelector('.multiple-variant-picker__total');
    this.totalPriceEl   = this.querySelector('.multiple-variant-picker__price-total');
    this.regularPriceEl = this.querySelector('.multiple-variant-picker__price--regular');

    // Build variant lookup: "option1|option2|option3" → variant object
    this.variants = JSON.parse(this.dataset.variants || '[]');
    this.variantMap = new Map(
      this.variants.map((v) => [
        [v.option1, v.option2, v.option3].filter(Boolean).join('|'),
        v,
      ])
    );

    // One array of checkboxes per option group (fieldset)
    this.fieldsets = Array.from(this.querySelectorAll('fieldset.mvp-fieldset'));

    // Default: check first available value in every option group
    this.fieldsets.forEach((fs) => {
      const first = fs.querySelector('input[type="checkbox"]:not(:disabled)');
      if (first) first.checked = true;
    });

    this.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.addEventListener('change', () => this.updateState());
    });

    this.addBtn.addEventListener('click', () => this.onAddToCart());

    // Sync with main quantity-input if present
    const sectionId = this.id.replace('MultipleVariantPicker-', '');
    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    if (quantityInput) {
      const sync = () => this.syncQuantity(parseInt(quantityInput.value) || 1);
      quantityInput.addEventListener('change', sync);
      quantityInput.addEventListener('input', sync);
    }

    this.updateState();
  }

  // Returns [[valA, valB], [valC], ...] – one array per option group
  getSelectedValues() {
    return this.fieldsets.map((fs) =>
      Array.from(fs.querySelectorAll('input[type="checkbox"]:checked')).map((cb) => cb.value)
    );
  }

  // Cartesian product of arrays
  cartesian(arrays) {
    return arrays.reduce(
      (acc, arr) => acc.flatMap((a) => arr.map((b) => [...a, b])),
      [[]]
    );
  }

  // Returns matched available variant objects for every selected combination
  resolveVariants() {
    // No option groups → default-variant product, return it directly
    if (this.fieldsets.length === 0) return this.variants.filter((v) => v.available);

    const selections = this.getSelectedValues();
    if (selections.some((s) => s.length === 0)) return [];
    return this.cartesian(selections)
      .map((combo) => this.variantMap.get(combo.join('|')))
      .filter((v) => v && v.available);
  }

  syncQuantity(qty) {
    this._qty = qty;
    this.updateState();
  }

  getQty() {
    const sectionId = this.id.replace('MultipleVariantPicker-', '');
    const input = document.getElementById(`Quantity-${sectionId}`);
    return parseInt(input ? input.value : (this._qty || 1)) || 1;
  }

  updateState() {
    const resolved = this.resolveVariants();
    this.addBtn.disabled = resolved.length === 0;

    if (resolved.length === 0) {
      // Nothing selected yet → show base product price
      const price    = parseInt(this.dataset.productPrice) || 0;
      const priceMax = parseInt(this.dataset.productPriceMax) || 0;
      const compare  = parseInt(this.dataset.productComparePrice) || 0;
      this.totalPriceEl.textContent = price !== priceMax
        ? `From ${this.formatMoney(price)}`
        : this.formatMoney(price);
      this.regularPriceEl.textContent = compare > price ? this.formatMoney(compare) : '';
      this.totalEl.classList.remove('hidden');
      return;
    }

    const qty = this.getQty();
    let totalPrice = 0, totalCompare = 0, hasCompare = false;

    resolved.forEach((v) => {
      const price   = v.price || 0;
      const compare = v.compare_at_price || 0;
      totalPrice += price * qty;
      if (compare > price) {
        totalCompare += compare * qty;
        hasCompare = true;
      } else {
        totalCompare += price * qty;
      }
    });

    this.totalPriceEl.textContent   = this.formatMoney(totalPrice);
    this.regularPriceEl.textContent = hasCompare ? this.formatMoney(totalCompare) : '';
    this.totalEl.classList.remove('hidden');
  }

  formatMoney(cents) {
    const format = (window.DT_THEME && window.DT_THEME.moneyFormat) || '{{amount}}';
    return window.Shopify.formatMoney(cents, format);
  }

  onAddToCart(properties = {}) {
    const resolved = this.resolveVariants();
    if (!resolved.length) return;

    const qty  = this.getQty();
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const spinner = this.addBtn.querySelector('.loading-overlay__spinner');

    this.addBtn.disabled = true;
    spinner.classList.remove('hidden');
    this.handleErrorMessage();

    const hasProps = Object.keys(properties).length > 0;
    const body = {
      items: resolved.map((v) => ({
        id: v.id,
        quantity: qty,
        ...(hasProps ? { properties } : {}),
      })),
    };
    if (cart && cart.getSectionsToRender) {
      body.sections     = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((data) => {
        spinner.classList.add('hidden');
        this.addBtn.disabled = false;
        if (data.status) {
          this.handleErrorMessage(data.description);
          throw new Error(data.description || 'Could not add items to cart.');
        }
        if (cart && cart.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
      })
      .catch((err) => {
        spinner.classList.add('hidden');
        this.addBtn.disabled = false;
        throw err;
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define('variant-checkboxes', VariantCheckboxes);
(function () {
  var CART_CHANGE_PATH = '/cart/change.js';
  var CART_BODY_SELECTOR = '.boost-sd__cart-item'; // hoặc '.boost-sd__cart-body'
  var LOADING_CLASS = 'loading';

  var loadingCountById = Object.create(null);

  var LOADING_OVERLAY_ATTR = 'data-boost-cart-loading-overlay';

  var LOADING_OVERLAY_HTML =
    '<div class="loading-overlay" ' + LOADING_OVERLAY_ATTR + '>' +
      '<div class="loading-overlay__spinner">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
          '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
        '</svg>' +
      '</div>' +
    '</div>';

  var STOP_LOADING_DELAY_MS = 1000;
  var stopLoadingTimerById = Object.create(null);

  function mountLoadingOverlay(el) {
    if (el.querySelector('[' + LOADING_OVERLAY_ATTR + ']')) return;
    el.insertAdjacentHTML('beforeend', LOADING_OVERLAY_HTML);
  }

  function unmountLoadingOverlay(el) {
    el.querySelectorAll('[' + LOADING_OVERLAY_ATTR + ']').forEach(function (node) {
      node.remove();
    });
  }

  function isCartChangeRequest(url) {
    if (!url) return false;
    try {
      return new URL(url, window.location.origin).pathname === CART_CHANGE_PATH;
    } catch (e) {
      return String(url).indexOf(CART_CHANGE_PATH) !== -1;
    }
  }

  /** Đọc id từ body (JSON / FormData / urlencoded). Bỏ qua chỉ có `line` (index dòng). */
  function getCartChangeIdsFromBody(body) {
    if (body == null) return [];

    var data = body;

    if (typeof body === 'string') {
      try {
        data = JSON.parse(body);
      } catch (e) {
        var params = new URLSearchParams(body);
        var urlId = params.get('id');
        return urlId ? [String(urlId)] : [];
      }
    }

    if (body instanceof FormData) {
      var formId = body.get('id');
      return formId ? [String(formId)] : [];
    }

    var ids = [];
    if (data.id != null && data.id !== '') ids.push(String(data.id));
    if (Array.isArray(data.items)) {
      data.items.forEach(function (item) {
        if (item && item.id != null) ids.push(String(item.id));
      });
    }
    return ids;
  }

  function findCartBodiesForId(id) {
    var selector =
      CART_BODY_SELECTOR +
      '[data-product-id="' +
      CSS.escape(String(id)) +
      '"]';
    var nodes = document.querySelectorAll(selector);

    // Fallback nếu Boost dùng variant id trên DOM
    if (!nodes.length) {
      nodes = document.querySelectorAll(
        CART_BODY_SELECTOR +
          '[data-variant-id="' +
          CSS.escape(String(id)) +
          '"]'
      );
    }
    return nodes;
  }

  function setLoadingForId(id, isLoading) {
    findCartBodiesForId(id).forEach(function (el) {
      if (isLoading) {
        el.classList.add(LOADING_CLASS);
        mountLoadingOverlay(el);
      } else {
        el.classList.remove(LOADING_CLASS);
        unmountLoadingOverlay(el);
      }
    });
  }

  function startLoading(ids) {
    ids.forEach(function (id) {
      if (stopLoadingTimerById[id]) {
        clearTimeout(stopLoadingTimerById[id]);
        delete stopLoadingTimerById[id];
      }
      loadingCountById[id] = (loadingCountById[id] || 0) + 1;
      if (loadingCountById[id] === 1) setLoadingForId(id, true);
    });
  }

  function stopLoading(ids) {
    ids.forEach(function (id) {
      loadingCountById[id] = Math.max(0, (loadingCountById[id] || 0) - 1);
      if (loadingCountById[id] > 0) return;

      if (stopLoadingTimerById[id]) {
        clearTimeout(stopLoadingTimerById[id]);
      }

      stopLoadingTimerById[id] = setTimeout(function () {
        delete stopLoadingTimerById[id];
        if (loadingCountById[id] > 0) return;
        setLoadingForId(id, false);
      }, STOP_LOADING_DELAY_MS);
    });
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isCartChangeRequest(url)) {
      return nativeFetch.apply(this, arguments);
    }

    var options = init || {};
    var ids = getCartChangeIdsFromBody(options.body);

    // Không có id trong payload → không add loading (ví dụ chỉ gửi line)
    if (!ids.length) {
      return nativeFetch.apply(this, arguments);
    }

    startLoading(ids);
    return nativeFetch.apply(this, arguments).finally(function () {
      stopLoading(ids);
    });
  };
})();

/** Boost add-to-cart buttons only: open theme cart-drawer after /cart/add.js when Boost cart drawer is disabled. */
(function initBoostCollectionThemeCart() {
  var SUPPRESS_MS = 3000;
  var BOOST_CART_ADD_WINDOW_MS = 5000;

  function isCartAddRequest(url) {
    if (!url) return false;
    try {
      return new URL(url, window.location.origin).pathname.endsWith('/cart/add.js');
    } catch (e) {
      return String(url).indexOf('/cart/add.js') !== -1;
    }
  }

  function parseBoostButtonMetadata(button) {
    if (!button) return null;
    var raw = button.getAttribute('data-metadata');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      try {
        return JSON.parse(raw.replace(/&quot;/g, '"'));
      } catch (innerError) {
        return null;
      }
    }
  }

  function isBoostAddToCartButton(button) {
    if (!button || !button.classList.contains('boost-sd__button')) return false;
    if (!button.closest('.boost-sd, [class*="boost-sd__"]')) return false;
    if (button.classList.contains('boost-sd__button--add-to-cart')) return true;

    var metadata = parseBoostButtonMetadata(button);
    return !!(metadata && metadata.action && metadata.action.addToCart);
  }

  function markBoostCartAddPending(event) {
    var button = event.target.closest('.boost-sd__button');
    if (!isBoostAddToCartButton(button)) return;
    window.__themeBoostCartAddPendingUntil = Date.now() + BOOST_CART_ADD_WINDOW_MS;
  }

  function isBoostCartAddPending() {
    return !!window.__themeBoostCartAddPendingUntil && Date.now() < window.__themeBoostCartAddPendingUntil;
  }

  document.addEventListener('click', markBoostCartAddPending, true);
  document.addEventListener('mousedown', markBoostCartAddPending, true);

  function requestIncludesCartSections(init) {
    var body = init && init.body;
    if (!body) return false;
    if (body instanceof FormData) return body.has('sections');
    if (typeof body === 'string') return body.indexOf('sections') !== -1;
    return false;
  }

  function shouldBlockCartRedirect(url) {
    if (!window.__themeSuppressCartRedirectUntil) return false;
    if (Date.now() > window.__themeSuppressCartRedirectUntil) return false;
    var path;
    try {
      path = new URL(String(url), window.location.origin).pathname;
    } catch (e) {
      path = String(url);
    }
    return path === '/cart' || path.endsWith('/cart');
  }

  function suppressCartRedirect() {
    window.__themeSuppressCartRedirectUntil = Date.now() + SUPPRESS_MS;
  }

  function installCartRedirectGuard() {
    if (window.__cartRedirectGuardInstalled) return;
    window.__cartRedirectGuardInstalled = true;

    var locationProto = window.Location && window.Location.prototype;
    if (locationProto) {
      var hrefDescriptor = Object.getOwnPropertyDescriptor(locationProto, 'href');
      if (hrefDescriptor && hrefDescriptor.set) {
        Object.defineProperty(locationProto, 'href', {
          configurable: true,
          enumerable: hrefDescriptor.enumerable,
          get: hrefDescriptor.get,
          set: function (url) {
            if (shouldBlockCartRedirect(url)) return;
            hrefDescriptor.set.call(this, url);
          },
        });
      }
    }

    var nativeAssign = window.location.assign.bind(window.location);
    window.location.assign = function (url) {
      if (shouldBlockCartRedirect(url)) return;
      return nativeAssign(url);
    };

    var nativeReplace = window.location.replace.bind(window.location);
    window.location.replace = function (url) {
      if (shouldBlockCartRedirect(url)) return;
      return nativeReplace(url);
    };

    document.addEventListener(
      'click',
      function (event) {
        if (!window.__themeSuppressCartRedirectUntil) return;
        if (Date.now() > window.__themeSuppressCartRedirectUntil) return;
        var link = event.target.closest('a[href]');
        if (!link) return;
        if (shouldBlockCartRedirect(link.href)) event.preventDefault();
      },
      true
    );
  }

  function ensureCartSections(data, cart) {
    if (data.sections && data.sections['cart-drawer']) {
      return Promise.resolve(data);
    }
    var sectionIds = cart.getSectionsToRender().map(function (section) {
      return section.id;
    }).join(',');
    return fetch(window.location.pathname + '?sections=' + sectionIds)
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        data.sections = Object.assign({}, data.sections || {}, sections);
        return data;
      });
  }

  function renderCartPageSections(data) {
    var cartItems = document.querySelector('cart-items');
    if (!cartItems || !cartItems.getSectionsToRender) return;

    var sections = cartItems.getSectionsToRender();
    var uniqueSectionIds = sections
      .map(function(s) { return s.section; })
      .filter(function(v, i, a) { return a.indexOf(v) === i; })
      .join(',');

    var promise = fetch(window.location.pathname + '?sections=' + uniqueSectionIds)
          .then(function(res) { return res.json(); })

    promise.then(function(allSections) {
      sections.forEach(function(section) {
        var el = document.getElementById(section.id);
        if (!el || !allSections[section.section]) return;
        var target = el.querySelector(section.selector) || el;
        target.innerHTML = cartItems.getSectionInnerHTML(allSections[section.section], section.selector);
      });
    }).catch(function(err) {
      console.error('Cart page sections render failed', err);
    });
  }

  function openThemeCartDrawerAfterAdd(data) {
    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      renderCartPageSections(data);
      document.getElementById('MainContent').scrollIntoView({
        behavior: "smooth"
      });

      return;
    }
    
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || !cart.renderContents) return;

    ensureCartSections(data, cart)
      .then(function (enriched) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        cart.renderContents(enriched);
      })
      .catch(function (err) {
        console.error('Theme cart drawer open failed', err);
      });
  }

  installCartRedirectGuard();

  function handleBoostCartAddResponse(getResponsePayload) {
    suppressCartRedirect();

    return getResponsePayload()
      .then(function (data) {
        if (data && !data.status) openThemeCartDrawerAfterAdd(data);
      })
      .catch(function () {});
  }

  function shouldInterceptBoostCartAdd(options) {
    if (requestIncludesCartSections(options || {})) return false;
    return isBoostCartAddPending();
  }

  function installCartAddXhrIntercept() {
    if (window.__boostCartAddXhrInstalled) return;
    window.__boostCartAddXhrInstalled = true;

    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__themeCartAddUrl = url;
      return xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;
      var url = xhr.__themeCartAddUrl;

      if (isCartAddRequest(url) && shouldInterceptBoostCartAdd({ body: body })) {
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          handleBoostCartAddResponse(function () {
            return Promise.resolve(JSON.parse(xhr.responseText));
          });
        });
      }

      return xhrSend.apply(this, arguments);
    };
  }

  installCartAddXhrIntercept();

  var prevFetch = window.fetch;
  if (typeof prevFetch !== 'function') return;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var options = init || {};
    var promise = prevFetch.apply(this, arguments);

    if (!isCartAddRequest(url) || !shouldInterceptBoostCartAdd(options)) {
      return promise;
    }

    return promise.then(function (response) {
      if (!response.ok) return response;

      handleBoostCartAddResponse(function () {
        return response.clone().json();
      });

      return response;
    });
  };
})();

/** Hide Boost cart modal and use Dawn cart-drawer instead. */
(function initThemeCartDrawerOverBoost() {
  function closeBoostCartModal() {
    var modal = document.getElementById('boost-sd__modal-cart');
    if (modal) {
      modal.classList.remove('boost-sd__modal--open');
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
    }
    document.body.classList.remove('boost-sd__cart-enabled');
    document.documentElement.classList.remove('boost-sd__modal-open');
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function openThemeCartDrawer(trigger) {
    closeBoostCartModal();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.open(trigger);
  }

  window.closeBoostCartModal = closeBoostCartModal;

  document.addEventListener(
    'click',
    function (event) {
      if (!document.querySelector('cart-drawer')) return;
      var cartIcon = event.target.closest('#cart-icon-bubble');
      if (!cartIcon) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openThemeCartDrawer(cartIcon);
    },
    true
  );

  function suppressBoostCartModal() {
    var modal = document.getElementById('boost-sd__modal-cart');
    if (!modal) return;

    modal.classList.remove('boost-sd__modal--open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove('boost-sd__cart-enabled');
    document.documentElement.classList.remove('boost-sd__modal-open');
  }

  var suppressTimer;
  function scheduleSuppress() {
    clearTimeout(suppressTimer);
    suppressTimer = setTimeout(suppressBoostCartModal, 0);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'childList') {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.id === 'boost-sd__modal-cart' ||
            (node.querySelector && node.querySelector('#boost-sd__modal-cart'))
          ) {
            scheduleSuppress();
            return;
          }
        }
      }
      if (
        mutation.type === 'attributes' &&
        (mutation.target.id === 'boost-sd__modal-cart' ||
          mutation.target === document.body ||
          mutation.target === document.documentElement)
      ) {
        scheduleSuppress();
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden', 'hidden', 'style'],
  });

  scheduleSuppress();
})();

/** Inject Wishlist Engine buttons into Boost collection product cards. */
// (function initBoostCollectionWishlist() {
//   var MARKER = 'data-boost-wishlist';
//   var WISHLIST_TEMPLATE = {
//     className: 'wishlist-engine',
//     fullButton: 'true',
//     css: 'true',
//   };

//   function isBoostProductGridContext() {
//     return !!document.querySelector('.boost-sd__product-item, .boost-sd__product-info-wrapper');
//   }

//   function parseBoostMetadata(button) {
//     if (!button) return null;
//     var raw = button.getAttribute('data-metadata');
//     if (!raw) return null;
//     try {
//       return JSON.parse(raw);
//     } catch (error) {
//       try {
//         return JSON.parse(raw.replace(/&quot;/g, '"'));
//       } catch (innerError) {
//         return null;
//       }
//     }
//   }

//   function parseBoostProductData(productItem) {
//     var raw = productItem.getAttribute('data-product');
//     if (!raw) return null;
//     try {
//       return JSON.parse(raw);
//     } catch (error) {
//       try {
//         return JSON.parse(raw.replace(/&quot;/g, '"'));
//       } catch (innerError) {
//         return null;
//       }
//     }
//   }

//   function isSelectOptionsItem(productItem) {
//     var selectButton = productItem.querySelector('.boost-sd__button--select-option[data-metadata]');
//     if (!selectButton) return false;

//     var metadata = parseBoostMetadata(selectButton);
//     if (!metadata || !metadata.action) return true;

//     return !!metadata.action.goToProductDetail && !metadata.action.addToCart;
//   }

//   var variantIdCacheByHandle = Object.create(null);

//   function fetchVariantIdFromHandle(handle) {
//     if (!handle) return Promise.resolve('');
//     if (variantIdCacheByHandle[handle]) {
//       return Promise.resolve(variantIdCacheByHandle[handle]);
//     }

//     var productUrl =
//       window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//         ? window.Shopify.routes.root + 'products/' + handle + '.js'
//         : '/products/' + handle + '.js';

//     return fetch(productUrl)
//       .then(function (response) {
//         return response.ok ? response.json() : null;
//       })
//       .then(function (product) {
//         if (!product || !product.variants || !product.variants.length) return '';
//         var variant =
//           product.variants.find(function (item) {
//             return item.available;
//           }) || product.variants[0];
//         var variantId = variant ? String(variant.id) : '';
//         if (variantId) variantIdCacheByHandle[handle] = variantId;
//         return variantId;
//       })
//       .catch(function () {
//         return '';
//       });
//   }

//   function getBoostProductIds(productItem) {
//     var productData = parseBoostProductData(productItem);
//     var productId =
//       productItem.getAttribute('data-product-id') ||
//       productItem.id ||
//       '';
//     var titleEl = productItem.querySelector('[id^="product-title-"]');
//     if (!productId && titleEl) {
//       productId = titleEl.id.replace('product-title-', '');
//     }
//     if (!productId) {
//       var priceEl = productItem.querySelector('[id^="product-price-"]');
//       if (priceEl) productId = priceEl.id.replace('product-price-', '');
//     }

//     var variantId = productData && productData.variantId ? String(productData.variantId) : '';
//     var handle = productData && productData.handle ? String(productData.handle) : '';

//     if (!variantId) {
//       var cartButton = productItem.querySelector(
//         '.boost-sd__button[data-metadata], [data-metadata].boost-sd__button--add-to-cart, [data-metadata].boost-sd__button--select-option'
//       );
//       var metadata = parseBoostMetadata(cartButton);
//       if (metadata && metadata.action && metadata.action.addToCart) {
//         variantId =
//           metadata.action.addToCart.productId || metadata.action.addToCart.variantId || '';
//       }
//     }

//     if (!handle) {
//       var productLink = productItem.querySelector('.boost-sd__product-link[href*="/products/"]');
//       if (productLink) {
//         var match = productLink.getAttribute('href').match(/\/products\/([^/?#]+)/);
//         if (match) handle = match[1];
//       }
//     }

//     return {
//       productId: String(productId || ''),
//       variantId: String(variantId || ''),
//       handle: handle,
//       isSelectOptions: isSelectOptionsItem(productItem),
//     };
//   }

//   function createWishlistEngineElement(productId, variantId, iconOnly) {
//     var el = document.createElement('div');
//     el.className = WISHLIST_TEMPLATE.className;
//     el.setAttribute(MARKER, 'true');
//     el.setAttribute('data-product_id', productId);
//     el.setAttribute('data-variant_id', variantId);
//     el.setAttribute('data-full_button', iconOnly ? 'false' : WISHLIST_TEMPLATE.fullButton);
//     el.setAttribute('data-css', WISHLIST_TEMPLATE.css);
//     return el;
//   }

//   function notifyWishlistEngine(nodes) {
//     if (!nodes || !nodes.length) return;

//     nodes.forEach(function (node) {
//       node.dispatchEvent(new CustomEvent('wishlist-engine-init', { bubbles: true }));
//     });

//     ['wishlistEngineRefresh', 'WishlistEngineRefresh', 'initWishlistEngine'].forEach(function (key) {
//       if (typeof window[key] === 'function') window[key]();
//     });
//   }

//   function mountWishlistElement(productItem, ids, variantId) {
//     if (!ids.productId || !variantId) return null;

//     var wishlistSlot = productItem.querySelector('.boost-sd__product-wishlist');
//     var hasAddToCartButton = !!productItem.querySelector('.boost-sd__button--add-to-cart');
//     var useImageSlot = !!wishlistSlot && (ids.isSelectOptions || !hasAddToCartButton);
//     var iconOnly = useImageSlot;
//     var wishlistEl = createWishlistEngineElement(ids.productId, variantId, iconOnly);

//     if (useImageSlot) {
//       wishlistSlot.innerHTML = '';
//       wishlistSlot.appendChild(wishlistEl);
//       return wishlistEl;
//     }

//     var productInfo = productItem.querySelector('.boost-sd__product-info');
//     var cartButton = productItem.querySelector(
//       '.boost-sd__button--add-to-cart, .boost-sd__button--select-option'
//     );

//     if (productInfo && cartButton) {
//       productInfo.insertBefore(wishlistEl, cartButton);
//     } else if (productInfo) {
//       productInfo.appendChild(wishlistEl);
//     } else if (wishlistSlot) {
//       wishlistSlot.innerHTML = '';
//       wishlistSlot.appendChild(wishlistEl);
//     } else {
//       var infoWrapper = productItem.querySelector('.boost-sd__product-info-wrapper');
//       (infoWrapper || productItem).appendChild(wishlistEl);
//     }

//     return wishlistEl;
//   }

//   function injectWishlistIntoBoostProduct(productItem) {
//     if (!productItem || productItem.querySelector('.' + WISHLIST_TEMPLATE.className + '[' + MARKER + ']')) {
//       return null;
//     }
//     if (productItem.getAttribute('data-boost-wishlist-pending') === 'true') {
//       return null;
//     }

//     var ids = getBoostProductIds(productItem);
//     if (!ids.productId) return null;

//     if (ids.variantId) {
//       return mountWishlistElement(productItem, ids, ids.variantId);
//     }

//     if (!ids.handle) return null;

//     productItem.setAttribute('data-boost-wishlist-pending', 'true');
//     fetchVariantIdFromHandle(ids.handle).then(function (variantId) {
//       productItem.removeAttribute('data-boost-wishlist-pending');
//       if (productItem.querySelector('.' + WISHLIST_TEMPLATE.className + '[' + MARKER + ']')) return;

//       var node = mountWishlistElement(productItem, ids, variantId);
//       if (node) notifyWishlistEngine([node]);
//     });

//     return null;
//   }

//   function initBoostWishlist(root) {
//     if (!isBoostProductGridContext()) return;

//     var scope = root && root.nodeType === 1 ? root : document;
//     var productItems = [];

//     if (scope.matches && scope.matches('.boost-sd__product-item')) {
//       productItems = [scope];
//     } else {
//       productItems = Array.from(scope.querySelectorAll('.boost-sd__product-item'));
//     }

//     if (!productItems.length && scope.querySelector('.boost-sd__product-info-wrapper')) {
//       productItems = [scope.closest('.boost-sd__product-item') || scope];
//     }

//     var injected = [];
//     productItems.forEach(function (productItem) {
//       if (!productItem) return;
//       var node = injectWishlistIntoBoostProduct(productItem);
//       if (node) injected.push(node);
//     });

//     notifyWishlistEngine(injected);
//   }

//   var debounceTimer;
//   function scheduleInit(root) {
//     clearTimeout(debounceTimer);
//     debounceTimer = setTimeout(function () {
//       initBoostWishlist(root);
//     }, 50);
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     scheduleInit(document);
//   });

//   if (document.readyState !== 'loading') {
//     scheduleInit(document);
//   }

//   var observer = new MutationObserver(function (mutations) {
//     for (var i = 0; i < mutations.length; i++) {
//       var mutation = mutations[i];
//       if (mutation.type !== 'childList') continue;

//       for (var j = 0; j < mutation.addedNodes.length; j++) {
//         var node = mutation.addedNodes[j];
//         if (node.nodeType !== 1) continue;
//         if (
//           node.matches('.boost-sd__product-item, .boost-sd__product-info-wrapper') ||
//           (node.querySelector &&
//             node.querySelector('.boost-sd__product-item, .boost-sd__product-info-wrapper'))
//         ) {
//           scheduleInit(node);
//           return;
//         }
//       }
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// })();
